export enum ThresholdType {
  Brand = 'brand',
  Category = 'category',
  Product = 'product',
}
